import { RandomUtil } from './../util/index';
export class AppEvent {
    constructor(message, id = RandomUtil.generateId(), causedAt = new Date()) {
        this.message = message;
        this.id = id;
        this.causedAt = causedAt;
    }
}
//# sourceMappingURL=app-event.js.map